<template>
  <div class="p-d-multi-obj">
    <div class="main">
      <div class="items" v-if="value && value.length">
        <div class="item" v-for="(item,index) in value"
             :key="index">
          <div class="number">
            {{ index + 1 }}
          </div>
          <div class="properties">
            <span class="property" v-for="(field,index) in template" :key="index">
              {{ renderProperty(item[field.field_id], field) || '-' }}
            </span>
          </div>
        </div>
      </div>
      <div class="tools">
              <span class="note">
                <template v-if="value && value.length">
                  {{ value.length }}
                  {{ 'item' | smart_s(value.length) }}
                </template>
                <template v-else>No items</template>
              </span>
      </div>
    </div>
  </div>
</template>

<script>
import {renderValueInCandidateItem} from "@/utils";

export default {
  name: "PDMultiObj",
  props: {
    template: Array,
    value: Array,
  },
  methods: {
    renderProperty: renderValueInCandidateItem,
  },
}
</script>

<style scoped lang="scss">
@import "../../assets/variables";

.p-d-multi-obj {
  .main {
    border: 1px solid lightgray;
    border-radius: 4px;
    line-height: 20px;
    background-color: white;
    padding: 6px 6px;

    .note {
      font-weight: 600;
      color: gray;
    }
  }
}

.tools {
  text-align: center;
  font-size: .86em;
}

.items {
  border-bottom: 1px solid lightgray;
  margin-bottom: 0.5rem;
  padding: 0.25rem 0 0.5rem;

  .item {
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
    display: flex;
    align-items: flex-start;
    position: relative;
    outline: none;

    .number {
      min-width: 1.2rem;
      margin-right: 0.75rem;
      font-weight: bold;
      font-size: 12px;
      color: gray;
      text-align: right;
    }

    &:not(:last-child) {
      margin-bottom: 0.25rem;
    }

    .properties {
      font-size: 14px;

      .property {
        &:not(:last-child) {
          &::after {
            content: ' / ';
            font-weight: bold;
            color: lightgray;
          }
        }
      }
    }
  }
}
</style>
